import React from 'react';
import Button from '../../components/Button';

const ConfirmFinish = ({ handleClick, testEnd }) => {
  return (
    <div className='confirm-finish-container'>
      <h1>Test ended</h1>
      <div>
        <p>Your test has finished.</p>
        <p>All of your answers have been stored.</p>
        <p>Please wait for further instructions.</p>
        {!testEnd && <Button btnText='Review answers' handleClick={handleClick} />}
      </div>
    </div>
  );
}

export default ConfirmFinish;
